import { Text as T } from '@eo-locale/preact';
import { ReviewSource } from 'types/review';

import { Stack } from 'components/Stack';
import { Text } from 'components/Text';
import { Tip } from 'components/Tip';

interface TipVerifiedProps {
  source: ReviewSource;
}

export function TipVerified({ source }: TipVerifiedProps) {
  const verificationMessageProps = getVerificationMessageProps(source);

  return (
    <Tip
      content={
        <Stack vertical>
          <Text variation="strong" size="large">
            <T
              id="review_verified_purchase_label"
              defaultMessage="Verified purchase"
            />
          </Text>
          <Text size="small">
            <T
              id={verificationMessageProps.id}
              defaultMessage={verificationMessageProps.defaultMessage}
            />
          </Text>
        </Stack>
      }
    />
  );
}

function getVerificationMessageProps(source: ReviewSource) {
  switch (source) {
    case 'ADMIN': {
      return {
        id: 'review_verified_by_store_owner_message',
        defaultMessage: 'This review is manually verified by a store owner.',
      };
    }
    case 'IMPORT': {
      return {
        id: 'review_verified_during_import_message',
        defaultMessage:
          'This review is imported and manually verified during the import process.',
      };
    }
    case 'SITE': {
      return {
        id: 'review_verified_by_app_message',
        defaultMessage:
          'This review was received from a verified customer who purchased this item. Verified automatically by the Webtex app matching an order and a review by a customer email.',
      };
    }
  }
}
